import { formatAccountLabel } from './accountSelection';

interface LinkedAccount {
  id: string;
  name: string;
  enabled?: boolean | null;
  bankAccount?: { id: string } | null;
}

export interface BankLinkedAccountOption {
  accountId: string;
  label: string;
}

/**
 * Comptes proposés pour la synchro bancaire d'un seul compte (page Admin).
 *
 * - Seuls les comptes liés à un compte bancaire sont proposés : les autres n'ont rien à synchroniser.
 * - Comptes de l'utilisateur puis comptes de ses groupes, dans l'ordre des groupes.
 * - Un même compte bancaire lié à plusieurs comptes n'est proposé qu'une fois, sur le premier
 *   rencontré : c'est la même règle que le back (`collectBudgetInsideLinkedAccounts`), qui refuse
 *   les autres comptes avec « account not linked to BudgetInside ».
 */
export function bankLinkedAccountOptions(
  userAccounts: LinkedAccount[],
  groups: Array<{ name: string; accounts: LinkedAccount[] }>,
): BankLinkedAccountOption[] {
  const candidates = [
    ...userAccounts.map((account) => ({ account, owner: 'perso' })),
    ...groups.flatMap((group) =>
      group.accounts.map((account) => ({ account, owner: group.name })),
    ),
  ];
  const seenBankAccountIds = new Set<string>();
  const options: BankLinkedAccountOption[] = [];
  for (const { account, owner } of candidates) {
    const bankAccountId = account.bankAccount?.id;
    if (!bankAccountId || seenBankAccountIds.has(bankAccountId)) {
      continue;
    }
    seenBankAccountIds.add(bankAccountId);
    options.push({
      accountId: account.id,
      label: `${formatAccountLabel(account.name, account.enabled)} (${owner})`,
    });
  }
  return options;
}
